import PlaylistsSelect from './PlaylistsSelect';

export default PlaylistsSelect;
